import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCartIcon, HeartIcon, ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';

// Cart icon component with badge
export const CartIcon = ({ cartCount, className = "h-5 w-5" }) => (
  <div className="relative">
    <ShoppingCartIcon className={className} />
    {cartCount > 0 && (
      <span className="absolute -top-3 -right-3 bg-yellow-400 text-black text-xs rounded-full h-5 w-5 flex items-center justify-center">
        {cartCount}
      </span>
    )}
  </div>
);

// Message icon component with unread badge
export const MessageIcon = ({ unreadCount, className = "h-5 w-5" }) => (
  <div className="relative">
    <ChatBubbleLeftRightIcon className={className} />
    {unreadCount > 0 && (
      <span className="absolute -top-3 -right-3 bg-yellow-400 text-black text-xs rounded-full h-5 w-5 flex items-center justify-center">
        {unreadCount}
      </span>
    )}
  </div>
);

const ActionItems = ({ items, activeItem, isMobile = false }) => {
  return (
    <>
      {items.map((item) => (
        item.onClick ? (
          <button
            key={item.name}
            onClick={item.onClick}
            className={`
              ${isMobile 
                ? 'flex items-center w-full px-4 py-2 text-sm text-white hover:bg-brand-teal-light rounded-md'
                : 'p-2 rounded-full text-white hover:bg-brand-teal-light hover:text-white'
              }
            `}
            aria-label={item.name}
          >
            <span className={isMobile ? 'mr-3' : ''}>{item.icon}</span>
            {isMobile && item.name}
          </button>
        ) : (
          <Link
            key={item.name}
            to={item.link}
            className={`
              ${isMobile 
                ? 'flex items-center w-full px-4 py-2 text-sm text-white rounded-md' 
                : 'p-2 rounded-full text-white hover:text-white'
              }
              ${activeItem === item.name 
                ? 'bg-brand-teal-dark' 
                : 'hover:bg-brand-teal-light'
              }
            `}
            aria-label={item.name}
          >
            <span className={isMobile ? 'mr-3' : ''}>{item.icon}</span>
            {isMobile && item.name}
          </Link>
        )
      ))}
    </>
  );
};

export default ActionItems; 